import React from 'react';
import { Target, Eye } from 'lucide-react';
import { whoWeAreImage } from '../data/mock';

const MissionVision = () => {
  return (
    <section className="bg-[#e2ede6] py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Mission & Vision */}
          <div className="space-y-12">
            <div className="flex gap-5 group">
              <div className="shrink-0 w-14 h-14 rounded-xl bg-white border border-[#0f5c3d]/10 flex items-center justify-center text-[#0f5c3d] group-hover:bg-[#0f5c3d] group-hover:text-white transition-colors">
                <Target className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <div>
                <h3
                  className="text-3xl text-[#0b1a2e] mb-3"
                  style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                >
                  Our Mission
                </h3>
                <p className="text-[#0b1a2e]/70 leading-relaxed">
                  Bridging Financial and Technical Know-How by balancing the
                  synergy of success, enhancing resources, technology, value and
                  wealth amongst competitive peers.
                </p>
              </div>
            </div>

            <div className="flex gap-5 group">
              <div className="shrink-0 w-14 h-14 rounded-xl bg-white border border-[#0f5c3d]/10 flex items-center justify-center text-[#0f5c3d] group-hover:bg-[#0f5c3d] group-hover:text-white transition-colors">
                <Eye className="w-6 h-6" strokeWidth={1.5} />
              </div>
              <div>
                <h3
                  className="text-3xl text-[#0b1a2e] mb-3"
                  style={{ fontFamily: 'Cormorant Garamond, serif', fontWeight: 500 }}
                >
                  Our Vision
                </h3>
                <p className="text-[#0b1a2e]/70 leading-relaxed">
                  Identify innovative business verticals, invest in futuristic
                  technologies, create opportunities and empower talents to
                  achieve and sustain the market leading position.
                </p>
              </div>
            </div>
          </div>

          {/* Right: Who we are */}
          <div className="relative">
            <div className="text-right mb-6">
              <span className="text-xs font-semibold tracking-[0.25em] text-[#0f5c3d] uppercase">
                Who We Are
              </span>
            </div>
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-tr from-emerald-200/50 to-transparent rounded-[40px] blur-2xl" />
              <div className="relative rounded-[32px] overflow-hidden shadow-xl bg-emerald-900">
                <img
                  src={whoWeAreImage}
                  alt="Who we are"
                  className="w-full aspect-[4/3] object-cover"
                  style={{ filter: 'grayscale(1) brightness(0.9) contrast(1.1)' }}
                />
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/70 via-emerald-600/55 to-emerald-800/70 mix-blend-multiply" />
                <div className="absolute inset-0 bg-emerald-500/25" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
